module.exports = __webpack_public_path__ + "media/src/assets/images/breakfast-8721dfde74f39ba075e4b851cffcffd4.png";